// extracted by mini-css-extract-plugin
module.exports = {"vipDashboard":"fm","grid":"gm","optInGrid":"hm","rewardsIneligible":"im"};